import React from "react";

export default function DeleteConfirm({ open, onCancel, onConfirm, itemName, testId }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-6 fade-anim"
      data-testid={testId}
    >
      <div className="absolute inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative w-full max-w-[320px] bg-white rounded-2xl shadow-2xl p-5">
        <h3 className="text-base font-bold text-slate-900">Hapus data?</h3>
        <p className="mt-2 text-sm text-slate-600">
          {itemName ? (
            <>
              Yakin ingin menghapus <span className="font-semibold text-slate-900">&quot;{itemName}&quot;</span>? Aksi ini tidak dapat dibatalkan.
            </>
          ) : (
            "Yakin ingin menghapus data ini? Aksi ini tidak dapat dibatalkan."
          )}
        </p>
        <div className="mt-5 flex gap-3">
          <button
            onClick={onCancel}
            data-testid={testId ? `${testId}-cancel` : "delete-cancel"}
            className="flex-1 tap py-2.5 rounded-xl bg-slate-100 text-slate-700 font-semibold text-sm"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            data-testid={testId ? `${testId}-confirm` : "delete-confirm"}
            className="flex-1 tap py-2.5 rounded-xl font-semibold text-sm text-white"
            style={{ backgroundColor: "#C00000" }}
          >
            Hapus
          </button>
        </div>
      </div>
    </div>
  );
}
